import { YoutubePlayer } from '@/presenters/components/catalog';

import type { MediaItem } from '../../Medias';

import styles from './Item.styles';

interface ItemProps extends MediaItem {
  isActive: boolean;
}

function Item(props: ItemProps) {
  const { alt, thumbSrc, type, videoId, isActive } = props;

  const classNames = styles();

  return (
    <div className={classNames.base()}>
      {type === 'video' && videoId ? (
        <YoutubePlayer
          videoId={videoId}
          isActive={isActive}
          autoplay
          className={classNames.youtubePlayer()}
          title={alt}
        />
      ) : (
        <picture>
          <img alt={alt} src={thumbSrc} />
        </picture>
      )}
    </div>
  );
}

export default Item;
